import React from "react"
import Slider from "react-slick"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import IntegrationCarouselVideo from "@/components/IntegrationCarouselVideo"
import IntegrationCarouselArrow from "@/components/IntegrationCarouselArrow"

const IntegrationCarousel = ({ data }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <IntegrationCarouselArrow />,
    prevArrow: <IntegrationCarouselArrow />,
    customPaging: function () {
      return <div className="integration-carousel__dots" />
    },
  }
  return (
    <div className="mb-10 integration-carousel">
      <Slider {...settings}>
        {data.map((item, index) =>
          item.video ? (
            <IntegrationCarouselVideo
              key={
                item.video.wistia_video_id ||
                item.video.youtube_url ||
                index
              }
              data={item.video}
            />
          ) : (
            <GatsbyImage
              key={item.image?.alt || index}
              image={getImage(item.image?.src) || item.image?.src?.gatsbyImageData}
              alt={item.image?.alt || ""}
              className="integration-carousel__image"
            />
          ),
        )}
      </Slider>
    </div>
  )
}

export default IntegrationCarousel
